module.exports = __webpack_public_path__ + "static/main_01-39c41428e78f0375299f64a0d9994563.png";